import { render } from "./ActCaptionCards.vue?vue&type=template&id=c9c80198"
import script from "./ActCaptionCards.vue?vue&type=script&lang=js"
export * from "./ActCaptionCards.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__